import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

const LINES = [["attitude", "Attitude", "#920e12"], ["behavior", "Behavior", "#1a1617"], ["skill", "Skill", "#c2410c"]];

export function ProgressChart({ history, name }) {
  const scored = history.filter((h) => h.attitude || h.behavior || h.skill);
  if (!scored.length) return <p className="mt-3 text-sm text-[#545454]">No scores yet. The chart appears after the first scored week.</p>;
  const last = Math.max(10, ...scored.map((h) => h.week));
  const byWeek = Object.fromEntries(scored.map((h) => [h.week, h]));
  const data = Array.from({ length: last }, (_, i) => ({ week: `W${i + 1}`, ...(byWeek[i + 1] || {}) }));
  return (
    <div className="mt-3 h-56" role="img" aria-label={`${name}'s weekly Attitude, Behavior and Skill scores`}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 8, right: 12, left: -20, bottom: 0 }}>
          <CartesianGrid stroke="#eee5e6" strokeDasharray="3 3" />
          <XAxis dataKey="week" tick={{ fontSize: 11, fill: "#545454" }} />
          <YAxis domain={[1, 5]} ticks={[1, 2, 3, 4, 5]} tick={{ fontSize: 11, fill: "#545454" }} />
          <Tooltip />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          {LINES.map(([k, l, c], i) => (
            <Line key={k} type="monotone" dataKey={k} name={l} stroke={c} strokeWidth={2.5} connectNulls
              strokeDasharray={i === 2 ? "6 3" : undefined} dot={{ r: 3 }} isAnimationActive={false} />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
